export enum CreditDispatchEvent {
  SET_USER_CREDITS = 'SET_USER_CREDITS',
  RESET = 'RESET',
}
